import { useEffect, useState } from "react";
import { fetchFromApi, getStorageUrl } from "../lib/api";

interface WorkIcon {
    id: number;
    icon: string;
    iconUrl: string;
}

export const useWorksIcons = () => {
    const [icons, setIcons] = useState<WorkIcon[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        const fetchIcons = async () => {
            try {
                setIsLoading(true);
                const data = await fetchFromApi("/works") as any[];

                const iconsWithUrls = data.map((item) => {
                    if (!item.icon_path) {
                        return null;
                    }

                    return {
                        id: item.id,
                        icon: item.name,
                        iconUrl: getStorageUrl("features", item.icon_path),
                    };
                });

                setIcons(
                    iconsWithUrls.filter((icon): icon is WorkIcon =>
                        icon !== null
                    ),
                );
            } catch (err) {
                console.error("Error in fetchIcons:", err);
                setError(
                    err instanceof Error
                        ? err
                        : new Error("Unknown error occurred"),
                );
            } finally {
                setIsLoading(false);
            }
        };

        fetchIcons();
    }, []);

    return { icons, isLoading, error };
};
